(() => {
  function initSwiper() {
    const slider = document.querySelector('.Benefits.swiper');
    if (!slider) return;

    const swiper = new Swiper(slider, {
      centerInsufficientSlides: true,
      centeredSlides: false,
      pagination: {
        el: ".swiper-pagination-benefits",
        clickable: true
      },
      autoHeight: false,
      spaceBetween: 0,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 12
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        1008: {
          slidesPerView: 3,
          spaceBetween: 0
        }
      },
      simulateTouch: true
    });
  }

  function waitForSwiper() {
    if (typeof Swiper !== 'undefined') {
      initSwiper();
    } else {
      setTimeout(waitForSwiper, 50); // Check alle 50ms
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSwiper);
  } else {
    waitForSwiper();
  }
})();